import { Box, Flex, Text } from "@storyofams/react-ui";
import Image from "next/image";
import Link from "next/link";

export const Bundle = ({ content }) => {
  return (
    <Box onClick={(e) => e.stopPropagation()}>
      {content.content.map(({ productVariant }, i) => (
        <Link
          key={productVariant.id}
          href={`/products/${productVariant.product.handle}`}
        >
          <Flex
            width={"100%"}
            mt={i && 1}
            cursor={"pointer"}
            alignItems={"center"}
          >
            <Box
              border={"1px solid #E2DFDF"}
              borderRadius={"6px"}
              overflow={"hidden"}
              width={[58, 53]}
              height={[58, 53]}
              flexShrink={1}
              position={"relative"}
              mr={"10px"}
            >
              <Image
                layout="fill"
                objectFit="cover"
                src={productVariant.image.url}
              ></Image>
            </Box>
            <Box>
              <Text
                fontWeight={500}
                lineHeight={["19.6px", "22.4px"]}
                fontSize={["14px", 2]}
              >
                {`1 × ${productVariant.product.title}`}
              </Text>
              <Text
                color={"#767473"}
                fontWeight={400}
                lineHeight={["16.8px", "19.6px"]}
                fontSize={["12px", "14px"]}
              >
                {productVariant.title}
              </Text>
            </Box>
          </Flex>
        </Link>
      ))}
    </Box>
  );
};
